import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import { BuyerUpsertDto, RetailClient } from 'src/WebApiController';

export function useUpsertBuyer() {
  const { activeAccountWebClientConfig } = useAppContext();
  const { showErrorDialog } = useClientLogContext();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (buyerUpsert: BuyerUpsertDto) => {
      return await new RetailClient(activeAccountWebClientConfig).upsertBuyer(
        buyerUpsert
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['GetSellerBuyersPaginated'] });
    },
    onError: (err: ErrorTypes) => {
      showErrorDialog('RetailClient.upsertBuyer', err as Error, {
        trackErrorData: {},
      });
    },
  });
}
